export const getRecurrentEntityFilter = state => state.recurrentEntityAdmin.filter
